import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

// Declarar grecaptcha globalmente
declare const grecaptcha: any;

@Component({
  selector: 'app-asesoria-form',
  templateUrl: './asesoria-form.component.html',
  styleUrls: ['../../landing-leasing/landing-leasing.component.scss', './asesoria-form.component.scss']
})
export class AsesoriaFormComponent implements OnInit, AfterViewInit {
  siteKey: string = '6Legt1ErAAAAABT3m7SimNZ46AjoPIcgYBSjN9qT'; // reCAPTCHA key
  isSubmitting: boolean = false;

  @Input() type = ""

  formData: any = this.formBuilder.group({
    lead_source: ['', Validators.required],
    first_name: ['', Validators.required],
    last_name: ['', Validators.required],
    email: ['', [Validators.required, this.validateEmail()]],
    phone: ['', [Validators.required, this.validatePhone()]],
    regimen_fiscal: ['', Validators.required],
    '00N8c00000WBdCa': ['', [Validators.required, this.validateRFC()]], // RFC
    '00N8c00000hQda8': ['', Validators.required], // Nivel de ingresos mensuales
    '00NPb00000JOm5N': ['', Validators.required], // Has tenido créditos
    '00NPb00000JOnW5': [''], // Auto deseado
    '00NPb00000JPXFZ': [''], // utm_campaign
    '00NPb00000JPXST': [''], // utm_campaign_name
    '00NPb00000JPY8P': [''], // utm_content
    '00NPb00000JPQVq': [''], // utm_medium
    '00NPb00000JPYd3': [''], // utm_term
    '00NPb00000JPWjL': [''], // utm_source
    'g-recaptcha-response': [''],

  })

  constructor(private http: HttpClient, private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    // Inicializar los campos UTM al cargar el componente
    this.formData.patchValue({
      '00NPb00000JPWjL': this.parseGET('utm_source'),
      '00NPb00000JPQVq': this.parseGET('utm_medium'),
      '00NPb00000JPXFZ': this.parseGET('utm_campaign'),
      '00NPb00000JPYd3': this.parseGET('utm_term'),
      '00NPb00000JPY8P': this.parseGET('utm_content'),
      lead_source: this.type
    })
  }

  ngAfterViewInit(): void {
    // Cargar el script de reCAPTCHA si no está cargado
    if (typeof grecaptcha === 'undefined') {
      const script = document.createElement('script');
      const scriptCaptcha = document.createElement('script')
      scriptCaptcha.src = `https://www.google.com/recaptcha/api.js`;
      script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      document.head.append(scriptCaptcha);
    }
  }

  validateRFC(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rfc: string = control.value;

      if (!rfc) {
        return null;
      }

      const rfcRegex = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]?$/;

      if (rfcRegex.test(rfc.toUpperCase())) {
        return null; 
      } else {
        console.log("invalido")
        return { invalidRfc: { value: rfc } }; 
      }
    };
  }

  validateEmail(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email: string = control.value;

      if (!email) {
        return null;
      }

 
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (emailRegex.test(email)) {
        return null; 
      } else {
        return { invalidEmail: { value: email } }; 
      }
    };
  }

  validatePhone(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneNumber: string = control.value;

      if (!phoneNumber) {
        return null;
      }

      const digitsOnlyRegex = /^\d{10}$/;
      if (!digitsOnlyRegex.test(phoneNumber)) {
        return { invalidPhoneFormat: true };
      }

      const allSameDigitsRegex = /^(.)\1{9}$/;
      if (allSameDigitsRegex.test(phoneNumber)) {
        return { allSameDigits: true };
      }

      return null; 
    };
  }

  parseGET(param: string): string {
    const searchStr = document.location.search;
    try {
      const match = searchStr.match('[?&]' + param + '=([^&]+)');
      if (match) {
        let result = match[1];
        result = result.replace(/\+/g, '%20');
        result = decodeURIComponent(result);
        return result;
      } else {
        return '';
      }
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  onSubmit(): void {
    this.isSubmitting = true;

    // Asegúrate de que grecaptcha esté cargado y listo
    if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(this.siteKey, { action: 'submit' })
          .then((token: string) => {
            this.formData.patchValue({
             'g-recaptcha-response': token 
            })
            this.submitFormProgrammatically();
          })
          .catch((error: any) => {
            console.error('Error al obtener el token de reCAPTCHA:', error);
            this.isSubmitting = false; // Habilitar el botón si hay un error
          });
      });
    } else {
      console.error('reCAPTCHA no está cargado o no está listo.');
      this.isSubmitting = false;
    }
  }

  private submitFormProgrammatically(): void {
    const form = document.getElementById('recaptForm') as HTMLFormElement;
    const sendForm = document.createElement('form')
    sendForm.id = "recaptForm"
    sendForm.classList.add("hidden")
    if (form) {
      // cargar inputs ocultos previos si existen
      const hiddenInputs = form.querySelectorAll('input[type="hidden"][name]');
      hiddenInputs.forEach((input) => {
        if (!['lead_source', 'g-recaptcha-response', '00NPb00000JPXFZ'].includes((input as HTMLInputElement).name)) {
          sendForm.appendChild(input)
        }
      });

      for (const key in this.formData.value) {
        if (this.formData.value.hasOwnProperty(key)) {
          const input = document.createElement('input');
          input.name = key;
          input.value = this.formData.value[key];
          sendForm.appendChild(input);
        }
      }
      document.body.appendChild(sendForm)
      sendForm.action = 'https://cloud.mx.bitcar.mx/contactanos-gracias';
      sendForm.method = 'POST';
      sendForm.submit();
    } else {
      console.error('Formulario no encontrado.');
      this.isSubmitting = false;
    }
  }

  get rfcControl() {
    return this.formData.get('00N8c00000WBdCa')
  }

  get phoneControl() {
    return this.formData.get('phone');
  }

  get emailControl() {
    return this.formData.get('email');
  }  

}
